import { render, staticRenderFns } from "./ResourceGroup.vue?vue&type=template&id=6cebd44d"
import script from "./ResourceGroup.ts?vue&type=script&lang=ts&external"
export * from "./ResourceGroup.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports